import React from 'react';
import { stats } from '../data/content';

function StatStrip() {
  return (
    <section className="stat-band" aria-label="Career statistics">
      <div className="stat-grid">
        {stats.map((stat) => (
          <div className="stat-item" key={stat.value}>
            <strong>{stat.value}</strong>
            <p>{stat.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatStrip;